import Vue from 'vue'
import Router from 'vue-router'
import mobile_index from '@/components/mobile_index'
import pc_index from '@/components/pc_index'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/mobile_index',
            name: 'mobile_index',
            component: mobile_index
        },
        {
            path: '/pc_index',
            name: 'pc_index',
            component: pc_index
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js